import type { Prototype } from "../prototype-types";

export const kevinBenscheidtPrototypes: Prototype[] = [
  {
    id: "kev-ads-manager-2-vkb",
    name: "Ads Manager 2.0 vKB",
    path: "/kev/ads-manager-2-vkb",
    description:
      "Kevin's fork of Ads Manager 2.0, for iteration without changing the interview prototype.",
    owner: "Kevin Benscheidt",
    createdAt: "2026-09-23",
    lastUpdated: "2026-09-23",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "/images/thumbnails/ads-manager-2.png",
    figmaLink:
      "https://www.figma.com/design/PHEir6eZP2VcqEn5OD5kOq/Ads-Manager-2.0",
    creationTool: "cursor",
    project: "Ads Manager 2.0",
  },
];
